<style lang="less" rel="stylesheet/less" scope></style>
<template>
  <el-tree
    :data="treeData"
    :props="defaultProps"
    :expand-on-click-node="false"
    @node-click="getNodeClick"
    :highlight-current="true"
    :render-content="renderContent"
    :accordion="true"
    :indent="10"
    node-key="id"
    :default-expanded-keys="expandedKeys">
  </el-tree>
</template>
<script type='text/ecmascript-6'>
  import { getTree } from '@/api/tree'
  import store from '@/store'

  export default {
    name: 'LyTreeLeft',
    props: {
      change: {
        type: Number,
        default: 0
      }
    },
    data: () => ({
      expandedKeys: [],
      defaultProps: {
        label: 'name'
      },
      treeData: [],
    }),
    created() {
      this.getTreeData();
    },
    methods: {
      getTreeData () {
        if (store.getters.tree&&store.getters.treeOper) {
          this.getTree();
        } else {
          store.dispatch('GetTreeData').then(() => {
            this.getTree();
          })
        }
      },
      refreshTokenTree() {
        store.dispatch('GetTreeData').then(() => {
          this.getTree();
        });
      },
      getTree() {
        this.treeData = store.getters.tree;
        let { province, city, county, id } = store.getters.tree[0];
        this.expandedKeys = [id];
        localStorage.userArea = JSON.stringify({ province, city, county, id });
      },
      renderContent(h, {node}) {
        return h('span', {
          'class': {
            'color-zi-line': node.data.isOwnLimit,
            'color-ji-line': !node.data.isOwnLimit
          },
          attrs: {
            title: node.label
          }
        }, [h('span', node.label, this.$slots.default)]);
      },
      getNodeClick(data, node, c) {
        this.$emit('nodeClick', data, node);
      },
    },
    watch: {
      change() {
        this.$store.commit('SET_TREE_OPER', false);
        this.getTreeData();
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/tree-left/index.vue